import { useEffect, useState } from "react";
import { SERVICE_MAP } from "@/data/services";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const absUrl = (u) => (u && u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export function usePortfolio() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND_URL}/api/portfolio`)
      .then((r) => (r.ok ? r.json() : []))
      .then((data) => {
        if (cancelled) return;
        const enriched = (Array.isArray(data) ? data : []).map((it) => ({
          ...it,
          pdf_url: absUrl(it.pdf_url),
          thumb_url: absUrl(it.thumb_url),
          service_title: SERVICE_MAP[it.service]?.title || "Land Surveying CAD",
        }));
        setItems(enriched);
        setLoaded(true);
      })
      .catch(() => {
        setItems([]);
        setLoaded(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { items, loaded };
}

export function groupByService(items) {
  const map = new Map();
  for (const it of items) {
    const key = it.service || "other";
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(it);
  }
  return Array.from(map.entries()).map(([slug, list]) => ({
    slug,
    title: SERVICE_MAP[slug]?.title || "Other",
    items: list,
  }));
}
